import posthog from 'posthog-js';

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  capture_pageview: false,
  persistence: 'localStorage',
});

export default posthog;
